<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="apn" class="col-sm-2 control-label">APN</label>
            <div class="col-sm-8">
                <input type="text" v-model="config.apn"  class="form-control" id="apn" >
            </div>
        </div>
        <div class="form-group">
            <label for="usuario" class="col-sm-2 control-label">USUÁRIO:</label>
            <div class="col-sm-3">
                <input type="text" v-model="config.usuario" class="form-control" id="usuario">
            </div>
            <label for="senha" class="col-sm-2 control-label">SENHA</label>
            <div class="col-sm-3">
                <input type="text" v-model="config.senha"  class="form-control" id="senha" >
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-sm btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import {Bus} from '../../../../class/bus';
    import {Vitana} from '../../../../class/vitana';
    export default {
        name: "ApnVitana",
        props: {
            config: {
                "default": null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Vitana.sendApn(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.log(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
